/*
 * @Description:
 * @Date: 2025-07-28 18:05:39
 */
import { WarningFilled } from '@element-plus/icons-vue';
import { useTableColumn, BaseIcon, BasePopover } from 'xrk-components';
import { formatter } from '@/utils';
import { ALL_INVOICE_STATUS } from '@V/invoice/src/constants';

/** 开票状态 */
export const invoiceStatusCol = useTableColumn({
  label: '开票状态',
  prop: 'invoiceStatus',
  width: '180px',
  render: ({ row, cellValue }) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <span>
          {formatter.defaultFormat(
            cellValue,
            () => ALL_INVOICE_STATUS[cellValue].label
          )}
        </span>
        {/* 已驳回。申请红冲被驳回(驳回的是待红冲，未到红票审核)时，状态回退到已开票(蓝票)的情况下展示驳回原因 */}
        {/* rejectReason对应的是申请开票驳回（-1），蓝红驳回是noPassReason。当-1时订单释放，不会基于当前数据更新，所以优先使用rejectReason。3、7会更新当前数据 */}
        {[-1, 3, 7].includes(cellValue) &&
          (row.rejectReason || row.noPassReason) && (
            <BasePopover
              placement="top"
              width="300px"
              title="驳回原因"
              trigger="hover"
              content={row.rejectReason || row.noPassReason}
              disabled={false}
              v-slots={{
                reference: () => (
                  <BaseIcon>
                    <WarningFilled />
                  </BaseIcon>
                )
              }}
            />
          )}
      </div>
    );
  }
});
